// extracted by mini-css-extract-plugin
export default {"collapse_container":"index_collapse_container__gm0d8"};